<template>
  <div>
    <div class="w-full px-6 h-20 flex justify-center items-center border-b relative">
      <h4 class="text-yank">Favorited Media <span class="text-payneHot">({{ $get(media, 'meta.total', 0) }})</span></h4>
    </div>
    <div>
      <div class="pt-5 px-10 flex items-start flex-col sm:flex-row">
        <div class="flex flex-wrap items-center">
          <SearchInput @search="addFilter('search', $event)" input-classes="bg-smoke h-10 w-full md:w-auto" class="mb-3 mr-4 text-sm" />
          <div flex flex-col md:flex-row>
            <FilterBadge
            v-if="activeFilters"
            v-for="(value, name) in activeFilters"
            :key="`filter-${name}-${value}`"
            :filter-val="value"
            :filter-name="name"
            @remove="removeFilter(name)"
            class="mb-3 mr-4"
          />
        </div>
       <FiltersDropdown
          :active-filters="activeFilters"
          :categories="categories"
          @apply-filters="applyFilters"
          @clear-filters="clearFilters"
          class="transition duration-300 ease-in-out rounded-full bg-payneHot text-white flex justify-center items-center font-medium ml-10 md:ml-0 mb-3 md:mb-0 px-5 h-10 border border-platinum focus:outline-none focus:border-yankFire focus:shadow-xl"
        >
          <template>
            <PlusIcon class="h-4"/>
            <span class="ml-3">Filter</span>
          </template>
          <template slot="filters">
            <TypeFilter
                v-model="filters.type"
                :enabled-filters="enabledFilters"
                @change="updateFilters('type', $event)"
              />
          </template>
        </FiltersDropdown>
          </div>
          
      </div>

      <!--Content-->
      <div class="border-t px-10 py-12 grid grid-cols-1 gap-y-16">
        <!--All media-->
        <section>
          <!-- <h4 class="font-bold text-2xl mb-4">All media</h4> -->
          <div class="flex flex-wrap">
            <ItemComponent :item="item" v-for="item in allMedia" :key="item.id" :with-favorite="true" class="p-2"/>
          </div>
          <infinite-loading ref="infiniteLoader" @infinite="loadMore">
            <div slot="spinner" class="items-grid mt-8">
              <item-skeleton v-for="item in 10" :key="`skeleton-item-${item}`"/>
            </div>
            <div slot="no-more" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
            <div slot="no-results" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
          </infinite-loading>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import AppLayout from '@/layout/app-layout';
import SearchInput from "@/components/shared/SearchInput";
import FilterBadge from "@/components/shared/FilterBadge";
import FiltersDropdown from "@/components/shared/Common/FiltersDropdown";
import PlusIcon from "@/components/svg/PlusIcon";
import ItemComponent from "@/components/home/CarouselItemComponent";
import ItemSkeleton from "@/components/shared/ItemSkeleton";
import InfiniteLoading from 'vue-infinite-loading';
import TypeFilter from '@/components/filters/TypeFilter';
import CategoryFilter from '@/components/filters/CategoryFilter';

export default {
  name: 'Favorites',

  layout: AppLayout,

  props: {
    filters: {
      type: Object,
      default: () => ({type: null})
    },
    media: Object|Array,
    categories: Array,
  },

  metaInfo: {
    title: 'Favorited Media',
  },

  components: {SearchInput, FilterBadge, FiltersDropdown, ItemComponent, ItemSkeleton, InfiniteLoading, PlusIcon,TypeFilter,CategoryFilter},

  remember: ['allMedia'],

  data() {
    return {
      working: false,
      activeFilters: this.filters || {},
      allMedia: this.media.data,
      enabledFilters: [],
    }
  },

  computed: {
    parsedFilters() {
      const filters = {}
      Object.keys(this.activeFilters).forEach(key => {
        if (this.activeFilters[key] === null) {
          delete this.activeFilters[key]
          return
        }

        let keyName = `filter[${key}]`
        filters[keyName] = this.activeFilters[key]
      })
      return filters
    },
  },

  methods: {
    loadMore($state) {
      if (this.$get(this.media, 'links.next', null) === null) {
        return
      }

      this.$inertia.visit(this.media.links.next, {
        preserveState: true,
        preserveScroll: true,
        only: ['media'],
        onFinish: () => {
          $state.loaded()
          if (!this.media.links.next) {
            $state.complete()
          }
        }
      })
    },

    updateFilters(name, event) {
      if (event.target.checked) {
        return this.$set(this.filters, name, event.target.value)
      }
      this.$set(this.filters, name, null)
    },

    addFilter(type, value) {
      this.$set(this.activeFilters, type, value)
      this.runSearch()
    },

    removeFilter(type) {
      delete this.activeFilters[type]
      this.runSearch()
    },

    applyFilters(filters) {
      this.runSearch()
    },

    clearFilters() {
      this.activeFilters = {}
      this.$inertia.visit(this.$route('home'))
    },

    runSearch() {
      this.$inertia.get(this.$route('media.favorites.index'), this.parsedFilters, {
        onStart: (visit) => this.working = true,
        onFinish: (visit) => this.working = false,
        only: ['media', 'filters'],
        preserveScroll: true,
      })
    },
  },

  watch: {
    media(media) {
      this.allMedia.push(...media.data)
    }
  },

  mounted() {
    if (this.$get(this.media, 'links.next', null) === null) {
      this.$refs.infiniteLoader.stateChanger.loaded()
      this.$refs.infiniteLoader.stateChanger.complete()
    }
  }
}
</script>
